import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { MAX_EXPORT_RECORDS, resolveExportErrorKey } from 'utils/orderExport';

/**
 * 把导出接口返回的 (errorCode, messageKey) 翻成可直接弹给客户的一句话。
 *
 * <p>提交、下载、记录页三处都用它，<b>不要在调用点自己 t(messageKey)</b>：
 *
 * <p>① 上限文案里的数字是 {{limit}} 插值而不是硬编码（服务端调上限时三语文案不必跟着改），
 * 漏传插值参数时 i18next 会把 "{{limit}}" 原样渲染给客户。集中在这一处传，就不存在漏传的调用点。
 *
 * <p>② messageKey 是跨仓下发的，本地不一定有译文，需要先探一次存在性，见 resolveExportErrorKey。
 */
export const useOrderExportError = () => {
    const { t, i18n } = useTranslation();

    return useCallback(
        (errorCode: string | null | undefined, messageKey: string | null | undefined): string => {
            const key = resolveExportErrorKey(errorCode, messageKey, (candidate) => i18n.exists(candidate));
            /* 上限按界面语言加千分位（en 10,000 / es 10.000），与 PRD 给的三语原文一致 */
            return t(key, { limit: MAX_EXPORT_RECORDS.toLocaleString(i18n.language) }) as string;
        },
        [t, i18n]
    );
};
